export enum HotelAccommodationTaxType {
  EXCLUDE = 'Exclude',
  INCLUDE = 'Include',
}
